<ng-template #floatingActionButtonMenu>
    <div class="grid">
        <div></div>
        <div [class]="{'showing': ((isShowingSmallMenu$|async)||isLargeMenuOpen()), 'full-width': isLargeMenuOpen()}"
             class="fab-wrapper" data-qa="action-menu-fab-wrapper">
            <div (click)="closeMenuFromMenu()" [class.showing]="((isShowingSmallMenu$|async)||isLargeMenuOpen())"
                 class="fab-items" data-qa="action-menu-fab-items">
                @if (isLargeMenuOpen()) {
                    <!-- need to use ng-content https://github.com/angular/angular/issues/64504 -->
                    <ng-content/>
                }
                @if (isShowingSmallMenu$|async) {
                    @if ((documentViewMode$|async) === DocumentViewModeEnum.Viewing || (documentViewMode$|async) === DocumentViewModeEnum.ClickFill || location() === PanelLocationEnum.Sidebar) {
                        @for (item of sortedActionItems(); track item.description()) {
                            @if (!item.hideInSmallMenu()) {
                                <app-button (clicked)="activateActionItem(item)"
                                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                            [buttonText]="(item.description() | translate) || ''"
                                            [qaTag]="location() + '-fab-item-' + item.tag()"
                                            [svgIcon]="item.svgIcon()"
                                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: (item.description() | translate) || '' }"
                                            class="fab-button"/>
                            }
                        }
                    } @else {
                        @if (((textItems$|async) && (documentViewMode$|async) === DocumentViewModeEnum.Viewing) || (documentViewMode$|async) === DocumentViewModeEnum.TextItems) {
                            <app-button (clicked)="searchForTextGlobal()"
                                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                        [buttonText]="'BUTTON.SEARCH_TEXT_GLOBAL' | translate"
                                        [qaTag]="'search-for-text-global'"
                                        [svgIcon]="ICONS.SEARCH_OVERALL"
                                        [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.SEARCH_TEXT_GLOBAL' | translate) }"
                                        class="fab-button"/>
                            <app-button (clicked)="searchForTextLocal()"
                                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                        [buttonText]="'BUTTON.SEARCH_TEXT_LOCAL' | translate"
                                        [qaTag]="'search-for-text-local'"
                                        [svgIcon]="ICONS.SEARCH_LOCAL"
                                        [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.SEARCH_TEXT_LOCAL' | translate) }"
                                        class="fab-button"/>
                            <app-button (clicked)="shareSearchText()"
                                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                        [buttonText]="'BUTTON.SHARE' | translate"
                                        [qaTag]="'share-search-text'"
                                        [svgIcon]="ICONS.SENDTO"
                                        [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.SHARE' | translate) }"
                                        class="fab-button"/>
                        }
                        @if ((documentViewMode$|async) === DocumentViewModeEnum.Annotations) {
                            <app-button (clicked)="saveAction()"
                                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                        [buttonText]="'BUTTON.SAVE' | translate"
                                        [qaTag]="'save-annotations-action-button'"
                                        [svgIcon]="ICONS.OK"
                                        [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.SAVE' | translate) }"
                                        class="fab-button"/>
                            @if ((selectedAnnotation$|async) && ((selectedAnnotation$|async)?.type !== 'signatures' || (isSelectedAnnotationTemporary$|async) === true) && ((selectedAnnotation$|async)?.type !== 'stamps' || (isSelectedAnnotationTemporary$|async) === true)) {
                                <app-button (clicked)="deleteAction()"
                                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                            [buttonText]="'BUTTON.REMOVE' | translate"
                                            [qaTag]="'delete-annotation-action-button'"
                                            [svgIcon]="ICONS.DELETEFINALLY"
                                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.REMOVE' | translate) }"
                                            class="fab-button"/>
                            }
                            @if ((selectedAnnotation$|async) && (countTemporaryAnnotations$|extAsync:0) > 1 && (selectedAnnotation$|async)?.type !== 'stamps') {
                                <app-button (clicked)="nextAction()"
                                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                            [buttonText]="'BUTTON.NEXT_ANNOTATION' | translate"
                                            [qaTag]="'next-annotation-action-button'"
                                            [svgIcon]="ICONS.NAVIGATE_NEXT"
                                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.NEXT_ANNOTATION' | translate) }"
                                            class="fab-button"/>
                            }
                            @if ((selectedAnnotation$|async)?.type !== 'stamps' && !isAddingStamp()) {
                                <app-button (clicked)="showAnnotationMenuAction()"
                                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                            [buttonText]="'BUTTON.ANNOTATIONS' | translate"
                                            [qaTag]="'show-annotation-menu-action-button'"
                                            [svgIcon]="ICONS.ANNOTATIONS"
                                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.ANNOTATIONS' | translate) }"
                                            class="fab-button"/>
                            }
                            @if (canShowNextButton()) {
                                <app-button (clicked)="saveStampAction()"
                                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                            [buttonText]="'BUTTON.STAMP_OK_NEXT' | translate"
                                            [qaTag]="'next-stamp-ok-action-button'"
                                            [svgIcon]="ICONS.STEMP_OK_NEXT_PAGE"
                                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.STAMP_OK_NEXT' | translate) }"
                                            class="fab-button"/>
                                <app-button (clicked)="cancelStampingAction()"
                                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                            [buttonText]="'BUTTON.STAMP_CANCEL_NEXT' | translate"
                                            [qaTag]="'next-stamp-cancel-action-button'"
                                            [svgIcon]="ICONS.STEMP_CANCEL_NEXT_PAGE"
                                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.STAMP_CANCEL_NEXT' | translate) }"
                                            class="fab-button"/>
                            }
                            @if ((selectedAnnotation$|async) && (selectedAnnotation$|async)?.type !== 'signatures' && (selectedAnnotation$|async)?.type !== 'stamps') {
                                <app-button (clicked)="copyAction()"
                                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                            [buttonText]="'BUTTON.COPY_ANNOTATION' | translate"
                                            [qaTag]="'copy-annotation-action-button'"
                                            [svgIcon]="ICONS.COPYITEM"
                                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.COPY_ANNOTATION' | translate) }"
                                            class="fab-button"/>
                            }
                        }
                        @if ((documentViewMode$|async) === DocumentViewModeEnum.Drawing) {
                            <app-button (clicked)="saveAction()"
                                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                                        [buttonText]="'BUTTON.CONFIRM' | translate"
                                        [qaTag]="'save-drawing-action-button'"
                                        [svgIcon]="ICONS.OK"
                                        [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: ('BUTTON.CONFIRM' | translate) }"
                                        class="fab-button"/>
                        }
                    }
                }
            </div>

            @if ((isShowingSmallMenu$|async) === false && !isLargeMenuOpen()) {
                <app-button (clicked)="openSmallMenu()"
                            (longPress)="openLargeMenu()"
                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                            [buttonColor]="ButtonColorEnum.RED"
                            [buttonText]="'BUTTON.ACTION_MENU' | translate"
                            [isLongPressButton]="true"
                            [qaTag]="location() + '-fab-button'"
                            [svgIcon]="ICONS.DREIPUNKTE"
                            class="fab-button floating-button"/>
            } @else {
                <app-button (clicked)="closeMenu()"
                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                            [buttonText]="'BUTTON.CLOSE' | translate"
                            [qaTag]="location() + '-fab-close-button'"
                            [svgIcon]="ICONS.CLOSE"
                            [tooltipData]="{ tooltipPosition: TooltipPositionEnum.LEFT, tooltipText: (documentViewMode$|async) === DocumentViewModeEnum.Drawing ? ('BUTTON.CANCEL' | translate) : '' }"
                            class="fab-button floating-button"/>
            }
        </div>
    </div>
</ng-template>

@if (isLargeMenuOpen()) {
    <app-panel [panelId]="panelId">
        <ng-container [ngTemplateOutlet]="floatingActionButtonMenu"/>
    </app-panel>
} @else {
    <ng-container [ngTemplateOutlet]="floatingActionButtonMenu"/>
}

